import React from "react";
import styled, { css } from "styled-components";

const StyledPrimaryBtn = styled.button`
  font-family: ${({ theme }) => theme.fonts.graphik};
  font-weight: 500;
  height: ${({ large }) => (large ? "56px" : "40px")};
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "auto")};
  min-width: ${({ large }) => (large ? "160px" : "80px")};
  padding: ${({ large }) => (large ? "16px" : "8px 16px")};
  color: ${({ theme }) => theme.colors.white};
  font-size: 1rem;
  line-height: 1.5rem;
  cursor: pointer;
  background-color: ${({ secondaryColor }) =>
    secondaryColor
      ? ({ theme }) => theme.colors.pink500
      : ({ theme }) => theme.colors.green500};
  border: none;
  transition: ${({ theme }) => theme.motion.short};
  &:hover {
    background-color: ${({ secondaryColor }) =>
      secondaryColor
        ? ({ theme }) => theme.colors.pink600
        : ({ theme }) => theme.colors.green600};
  }
  &:active {
    background-color: ${({ secondaryColor }) =>
      secondaryColor
        ? ({ theme }) => theme.colors.pink600
        : ({ theme }) => theme.colors.green700};
  }

  ${props =>
    props.disabled &&
    css`
      background-color: ${({ theme }) => theme.colors.gray600};
      cursor: not-allowed;
      &:hover {
        color: ${({ theme }) => theme.colors.white};
        background-color: ${({ theme }) => theme.colors.gray600};
      }
    `}
`;

const PrimaryBtn = ({
  children,
  className,
  onClick,
  disabled,
  large,
  fullWidth,
  secondaryColor
}) => {
  return (
    <StyledPrimaryBtn
      onClick={onClick}
      className={className}
      disabled={disabled}
      large={large}
      fullWidth={fullWidth}
      secondaryColor={secondaryColor}
    >
      {children}
    </StyledPrimaryBtn>
  );
};

PrimaryBtn.defaultProps = {
  disabled: false,
  large: false,
  fullWidth: false
};

export default PrimaryBtn;
